import { VALID_EMAIL as VALID_EMAIL_REGEX } from 'marketing-site/lib/validEmail'
import { IsMatchingRegexpValidator } from './IsMatchingRegexp.validator'

export const WRONG_EMAIL_ERROR = 'Must be valid email. example@yourdomain.com.'
export const IsEmailValidator = (error = WRONG_EMAIL_ERROR) =>
  IsMatchingRegexpValidator(VALID_EMAIL_REGEX, error)
